import { render, staticRenderFns } from "./app-base.vue?vue&type=template&id=005a2c8d&"
import script from "./app-base.vue?vue&type=script&lang=js&"
export * from "./app-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports